// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"144":"560893b4","818":"0b061700","904":"2daf0815","994":"f807ccc2"}[chunkId] + ".chunk.css";
};